module.exports = "\n"


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src1967356326/src/src/app/common/auto-logout/auto-logout.component.html
// module id = ../../../../../src/app/common/auto-logout/auto-logout.component.html
// module chunks = main